import { Button } from "@mui/material";
import crmImg from '../../assets/img/crm.svg';
import { whatsappUrl } from '../../helpers/Functions';

export default function CrmButton() {
    return (
        <div style={{ textAlign: "right" }}>
            <a href={whatsappUrl} target="_blank" rel="noreferrer">
                <Button sx={{
                    width: '38px',
                    minWidth: '38px',
                    height: '38px',
                    borderRadius: '50%',
                    border: ' 1px solid #EEEEEE',
                    boxShadow: '-2px -2px 7px #FFFFFF, 1px 1px 10px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#FFFFFF',
                    cursor: 'pointer',
                }} round='true'>
                    <img src={crmImg} />
                </Button>
            </a>
        </div>
    );
}
